import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setDoctorOpdFee, setPassword, setSettingsData, updateUser } from '../Store/authSlice';
import { setPatientQueueAndHistoryQueueEmpty } from '../Store/commonSlice';
import { setAppointmentSetting } from '../Store/authSlice';
import useApi from '../useApis';
const useSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const api = useApi();
  const signIn = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.sigin(params);
    if (response?.data?.headers?.code === 200) {
      dispatch(setPassword(params?.password));
      dispatch(setPatientQueueAndHistoryQueueEmpty());
      if (response?.data?.body?.settingsData) {
        dispatch(setSettingsData(response?.data?.body?.settingsData));
        dispatch(
          setAppointmentSetting({
            ...response?.data?.body?.settingsData,
            isAppointment: response?.data?.body?.clinicData[0]?.isAppointment,
            isFollowUp: response?.data?.body?.clinicData[0]?.isFollowUp
          })
        );
      }

      if (typeof onCancel === 'function') onCancel();
      dispatch(updateUser(response?.data?.body));
     
      dispatch(setDoctorOpdFee(response?.data?.body?.clinicData[0]?.clinicFees));
      // triggerToast('Signed In successfully');
      toast.success('Signed In successfully');
      navigate('/dashboard');
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  return {
    loading,
    signIn
  };
};

export default useSignIn;
